import { render, staticRenderFns } from "./resourceIndex.vue?vue&type=template&id=40f6f87a&scoped=true&"
import script from "./resourceIndex.vue?vue&type=script&lang=js&"
export * from "./resourceIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f6f87a",
  null
  
)

export default component.exports